// src/About.js

import React from 'react';

const About = () => {
  return (
    <div className="about-page">
      <h1>About Us</h1>
      <p>
        Welcome to FCTacticDB! Our website is dedicated to providing high-quality tactics & information for a couple of football games. Our goal is to help users learn and easily share tactics that can be used in FIFA, EAFC and FM.
      </p>
      <h2>Our Mission</h2>
      <p>
        Our mission is to make quality tactics availible to everyone. We believe in providing easy to use tools that allow people to make informed decisions.
      </p>
      <h2>Why We Started</h2>
      <p>
        Our journey began with my YouTube channel 'Geografifa'. Since then, I've grown into a resource for save ideas, so thought it was time to expand into tactics. We continue to work hard to maintain trust.
      </p>
      <h2>Meet the Team</h2>
      <p>
        Our team consists of several tactic masters on Discord & Geografifa.
      </p>
    </div>
  );
};

export default About;
